import Icon01 from '@images/svg/form/01-titel.svg';
import Icon04 from '@images/svg/form/04-zukunftsfaehig.svg';
import Icon05 from '@images/svg/form/05-region.svg';
import Icon06 from '@images/svg/form/06-preisgeld.svg';
import Icon07 from '@images/svg/form/07-medien.svg';
import Icon08 from '@images/svg/form/08-vorname.svg';
import Icon14 from '@images/svg/form/14-fast-geschafft.svg';
import React from 'react';
import {
  StepAboutYourself,
  StepDateOfBirth,
  StepDescription,
  StepEmail,
  StepFirstname,
  StepHowSolutionSustainable,
  StepLastname,
  StepMedia,
  StepRegionOrPlace,
  StepSubmit,
  StepTitle,
  StepUsePrizeMoney,
  StepWhichRegion,
  StepWhyPromoteYourRegion,
  StepWhySolutionNeeded
} from '../components/SubmissionStepViews';

export const SubmissionGroups = [
  {
    icon: <Icon01 />,
    title: 'Deine Idee',
    spanSteps: 3
  },
  {
    icon: <Icon04 />,
    title: 'Zukunftsfähigkeit',
    spanSteps: 1
  },
  {
    icon: <Icon05 />,
    title: 'Förderung der Region',
    spanSteps: 2
  },
  {
    icon: <Icon06 />,
    title: 'Preisgeld-Zweck',
    spanSteps: 1
  },
  {
    icon: <Icon07 />,
    title: 'Bilder',
    spanSteps: 1
  },
  {
    icon: <Icon08 />,
    title: 'Über Dich',
    spanSteps: 6
  },
  {
    icon: <Icon14 />,
    title: 'Fast geschafft!',
    spanSteps: 1
  }
];

export const SubmissionSteps = [
  {
    headline: 'Wie heißt Deine Idee?',
    view: <StepTitle />,
    isValid: () => true
    // isValid: context => {
    //   return context.title?.trim() !== '';
    // }
  },
  {
    headline: 'Beschreibe Deine Idee:',
    view: <StepDescription />,
    isValid: () => true
    // isValid: context => context.description?.trim() !== ''
  },
  {
    headline: 'Warum ist Deine Idee wichtig?',
    view: <StepWhySolutionNeeded />,
    isValid: () => true
    // isValid: context => context.whySolutionNeeded?.trim() !== ''
  },
  {
    headline: 'Wie stellst Du sicher, dass Deine Idee langlebig und nachhaltig ist?',
    view: <StepHowSolutionSustainable />,
    isValid: () => true
    // isValid: context => context.howSolutionSustainable?.trim() !== ''
  },
  {
    headline: 'Welche Region wird mit Deiner Idee gefördert?',
    view: <StepWhichRegion />,
    isValid: () => true
    // isValid: context => context.whichRegion?.trim() !== ''
  },
  {
    headline: 'Und wie fördert Deine Idee diese Region?',
    view: <StepWhyPromoteYourRegion />,
    isValid: () => true
    // isValid: context => context.whyPromoteYourRegion?.trim() !== ''
  },
  {
    headline: 'Wofür würdest Du das Preisgeld verwenden?',
    view: <StepUsePrizeMoney />,
    isValid: () => true
    // isValid: context => context.usePrizeMoney?.trim() !== ''
  },
  {
    headline: 'Ergänze einige Bilder zu Deiner Idee:',
    view: <StepMedia />,
    isValid: () => true
  },
  {
    headline: 'Bitte verrate uns Deinen Vornamen:',
    view: <StepFirstname />,
    isValid: () => true
    // isValid: context => context.firstname?.trim() !== ''
  },
  {
    headline: 'Und wie lautet Dein Nachname?',
    view: <StepLastname />,
    isValid: () => true
    // isValid: context => context.lastname?.trim() !== ''
  },
  {
    headline: 'Möchtest Du etwas zu Dir erzählen?',
    view: <StepAboutYourself />,
    isValid: () => true
  },
  {
    headline: 'Wie lautet Dein Geburtsdatum?',
    view: <StepDateOfBirth />,
    isValid: context =>
      context.dateOfBirth?.trim() === '' ||
      /^\d\d\.\d\d\.\d\d\d\d$/.test(context.dateOfBirth?.trim()),
    invalidMessage: 'Bitte verwende das Format: TT.MM.JJJJ',
    invalidMessageCanShow: context => context.dateOfBirth?.trim() !== ''
  },
  {
    headline: 'Bitte verrate uns Deine E-Mail-Adresse:',
    view: <StepEmail />,
    isValid: context =>
      context.email?.trim() === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(context.email?.trim()),
    invalidMessage: 'Bitte prüfe Deine E-Mail-Adresse',
    invalidMessageCanShow: context => context.email?.trim() !== ''
  },
  {
    headline: 'Möchtest Du angeben, wo Du wohnst?',
    view: <StepRegionOrPlace />,
    isValid: () => true
  },
  {
    headline: 'Fast geschafft!',
    view: <StepSubmit />,
    isValid: context => context.acceptTerms === true
  }
];
